import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`
